module.exports={
    // 登录页
    sjhm: 'رقم الجوال',
    qsrdxyzm:'يرجى إدخال رمز التحقق',
    fsyzm:'إرسال رمز التحقق',
    login:'تسجيل الدخول',
    yIDhmmdl:'تسجيل الدخول بالمعرف وكلمة المرور',
    qsrID:'يرجى إدخال المعرف',
    qsrmm:'يرجى إدخال كلمة المرور',
    ysjhmdl:'تسجيل الدخول برقم الجوال',
	xzsq	:'يرجى اختيار المجتمع',
	zhmmcw	:'خطأ في اسم المستخدم أو كلمة المرور',
    注册管理员:'تسجيل مدير',
    公司名:'اسم الشركة',
    //新添加的
    zc:'التسجيل',
    zhmm:'إعادة تعيين كلمة المرور',
    qsrsjhm:'يرجى إدخال رقم الجوال',
    mhzxhq:'إعادة الحصول عليه بعد ثوانٍ',
    hqyzmsb:'فشل في الحصول على رمز التحقق!',
    sbbczhmqx:'الجهاز غير موجود أو ليس لديه صلاحية!',
    ryzc:'تسجيل الموظف',
    sfz:'بطاقة الهوية',
    hz:'جواز السفر',
    jzz:'تصريح الإقامة',
    jsz:'رخصة قيادة',
    nbool:'ذكر',
    ngril:'أنثى',
    qxkmmm:'يرجى ملء كلمة مرور فتح الباب!',
    qxgh:'يرجى ملء رقم التعريف!',
    scgg:'نجحت الإرسال',
    scsb:'فشل الإرسال',
	tpgxsb:'فشل تحديث الصورة',
    xlh:'الرقم التسلسلي',
    wsh:'لم يتم مراجعته',
    ysh:'تمت المراجعة',
    rq:'التاريخ',
    cd:'تأخير',
    jb:'ساعات إضافية',
    zat:'مغادرة مبكرة',
    qtxbt:'يرجى ملء العنوان',
    qtxnr:'يرجى ملء المحتوى',
    ysdfkgx:'لقد تلقينا ملاحظاتكم. شكراً لملاحظاتكم القيمة!',
    fksb:'فشل الإرسال',
    lya:'فتح البلوتوث',
    ss:'بحث',
    lykm:'فتح الباب بالبلوتوث',
    cx:'استعلام',
    yc:'مرة واحدة',
    lc:'مرتين',
    zx:'متصل',
    lx:'غير متصل',
    kmen:'فتح الباب',
    
    // 首页
    yckm:'فتح الباب عن بُعد',
    fkyy:'حجز زائر',
    fxys:'مشاركة المفتاح',
    ewmkm:'فتح الباب بالرمز الشعاعي',
    smkm:'مسح لفتح',
    yjkm:'فتح بضغطة واحدة',
    sy:'الصفحة الرئيسية',
    zzzc:'التسجيل الذاتي',
    sb:'الجهاز',
    wd:'حسابي',
	cw:'خطأ',
    // 远程开门页面
    sbmhzwz:'اسم الجهاز أو الموقع',
    cxwz:'استعلام الموقع',
    sbwz:'موقع الجهاز',
    zt:'الحالة',
    km:'فتح الباب',
    kmcg:'نجح فتح الباب',
    kmsb:'فشل فتح الباب',
    // 访客预约页面
    xm:'الاسم',
    rlzp:'صورة الوجه',
    tj:'إضافة',
    zjlx:'نوع الوثيقة',
    zjh:'رقم الوثيقة',
    xb:'الجنس',
    sfcs:'المحافظة والمدينة',
    sxrs:'عدد المرافقين',
    syo:'السبب',
    fwyxq:'صلاحية الزيارة',
    bfrhm:'رقم الشخص المقابل',
    bfrxm:'اسم الشخص المقابل',
    tjyy:'إرسال الطلب',
    // 分享钥匙页面
    sssb:'بحث الجهاز',
    xzsb:'اختيار الجهاز',
    wsb:'لا يوجد جهاز',
    fwcs:'عدد الزيارات',
    bxcs:"لا حدود",
    qjzewmdzjt:'(يرجى توجيه هذا الرمز الشعاعي إلى عدسة الجهاز لفتح الباب)',
    fxewm:'إنشاء رمز شعاعي لمشاركة',
	fxmm:'مشاركة كلمة المرور',
    // 自主注册页面
    jg:'المكان الأصلي',
    hj:'المقاطعة',
    qybm:'قسم الشركة',
    kh:'رقم البطاقة',
    kmmm:'كلمة مرور فتح الباب',
    gh:'رقم التعريف',
    qd:'تأكيد',
    qtxsjhm:'يرجى ملء رقم الجوال',
    qtxxm:'يرجى ملء الاسم',
    qxzbm:'يرجى اختيار القسم',
    qszkmmm:'يرجى تعيين كلمة مرور فتح الباب',
    qtxgh:'يرجى ملء رقم التعريف',
    zccg:'نجح التسجيل',
    zcsb:'فشل التسجيل',
    // 我的页面
    txjl:'سجل المرور',
    fkjl:'سجل الزائر',
    kqrb:'تقرير الحضور',
    fkwm:'إرسال ملاحظات',
    tcdl:'تسجيل الخروج',
    // 通行记录页面
    txsj:'وقت المرور',
    kmlx:'نوع فتح الباب',
    // f访客记录页面
    lfsj:'وقت الزيارة',
    shzt:'حالة المراجعة',
    mygd:'لا يوجد المزيد',
    // 反馈我们页面
    bt:'العنوان',
    qsrbt:'يرجى إدخال العنوان',
    ly:'رسالة',
    qsrly:'يرجى إدخال الرسالة',
    tjfk:'إرسال الملاحظات',
    zhxx:'معلومات الحساب',
    // 退出登录页面
    sfqdtc:'هل أنت متأكد من تسجيل الخروج؟',
    qx:'إلغاء',
	// 设备搜索页面
	sbss:'بحث الجهاز',
	kysb:'الأجهزة المتاحة',
	ssjg:'نتائج البحث',
	sbtj:'إضافة الجهاز',
	sblx:'نوع الجهاز',
	sfwzcj:'هل هو جهاز مسجل؟',
	qxz:'يرجى الاختيار',
	azwz:'موقع التركيب',
	kmzt:'حالة فتح الباب',
	wifimm:'كلمة مرور واي فاي',
	
	// 设备设置页面
	wlgl:'إدارة الشبكة',
	yggl:'إدارة الموظفين',
	qxfp:'تخصيص الصلاحيات',
	gxqx:'تحديث الصلاحيات',
	cqsb:'إعادة تشغيل الجهاز',
	cshsb:'تهيئة الجهاز',
	scsb:'حذف الجهاز',
	cshPopTips:'سيؤدي هذا الإجراء إلى حذف جميع صلاحيات المستخدم.',
	qjscz:'يرجى توخي الحذر!',
	qrgxqxm:'هل تريد تأكيد تحديث الصلاحيات؟',
	qrcqsbm:'هل تريد تأكيد إعادة تشغيل الجهاز؟',
	dqczjscsb:'سيؤدي هذا الإجراء إلى حذف الجهاز.',
	shgl:'إدارة المراجعة',
	bmgl:'إدارة الأقسام',
	rygl:'إدارة الموظفين',
	ts:'ملاحظة',
	sbsccg:'نجح حذف الجهاز',
	sbbcz:'الجهاز غير موجود',
	sbyc:'الجهاز غير طبيعي، يرجى التحقق مما إذا كان متصلاً',
	mqxhzhmmcw:'لا توجد صلاحية أو خطأ في كلمة المرور',
	gxqxsb:'فشل تحديث الصلاحيات، رمز الخطأ',
	gxqxcg:'نجح تحديث الصلاحيات',
	sfyzgq:'انتهت صلاحية المصادقة، يرجى تسجيل الدخول مرة أخرى',
	qsryhmm:'يرجى إدخال كلمة المرور',
	qcsbcg:'نجح مسح الجهاز',
	mmcw:'كلمة المرور خاطئة',
	sbbzxhyc:'الجهاز غير متصل أو غير طبيعي',
	// 网络管理页面
	czsb:'عثور على الجهاز',
	wifisz:'إعدادات واي فاي',
	qsrSSID:'يرجى إدخال SSID',
	ytwsz:'إعدادات اتصال الإنترنت',
	DHCPms:'وضع DHCP',
	IPdz:'عنوان IP',
	zwym:'قناع الشبكة',
	wg:'بوابة',
	qsrIP:'يرجى إدخال IP',
	qsrMASK:'يرجى إدخال MASK',
	qsrGATEWAY:'يرجى إدخال GATEWAY',
	sgsz:'إعدادات 4G',
	tjxg:'إرسال التعديل',
	qxljsb:'يرجى توصيل الجهاز أولاً',
	qxzms:'يرجى اختيار الوضع',
	bnwk:'لا يمكن أن يكون فارغاً',
	wificsszcg:'نجحت إعداد معلمات واي فاي',
	wifiszsbcwm:'فشل إعداد واي فاي، رمز الخطأ',
	mmszsb:'فشل إعداد كلمة المرور',
	szwlmssb:'فشل إعداد وضع الشبكة',
	ipdzbnwk:'عنوان IP لا يمكن أن يكون فارغاً',
	ytwcsszcg:'نجحت إعداد معلمات اتصال الإنترنت',
	ytwcsszsb:'فشل إعداد اتصال الإنترنت',
	kqcg:'نجحت التفعيل',
	gbcg:'نجحت الإيقاف',
	kqsb:'فشل التفعيل',
	opentips:'فشل فتح الباب! إذا فشل عدة مرات، يرجى إعادة توصيل الجهاز ومحاولة مرة أخرى',
	
	sbtjcgzzszwifics:'نجحت إضافة الجهاز، يتم إعداد معلمات واي فاي',
	sbtjcg:'نجحت إضافة الجهاز',
	zzcxpzwifi:'جارٍ إعادة تشكيل واي فاي',
	sbycz:'الجهاز موجود بالفعل',
	tjsbsb:'فشل إضافة الجهاز',
	// 部门管理
	gm:'تغيير الاسم',
	sc:'حذف',
	xgcg:'نجحت التعديل',
	bmbcz:'القسم غير موجود',
	myqxhzhcw:'لا توجد صلاحية أو خطأ في الحساب',
	sbhryygl:'الجهاز أو الموظف مرتبط بالفعل، يجب مسح الارتباط أولاً',
	tjcg:'نجحت الإضافة',
	yczgwj:'الملف موجود بالفعل',
	gjdbnbcz:'لا يمكن تشغيل هذا العقد',
	bmsc:'حذف القسم',
	xgmc:'تعديل الاسم',
	tjdbmmc:'اسم القسم المضاف',
	tjzbm:'إضافة قسم فرعي',
	// 人员管理页面
	bm:'القسم',
	wsp:'لم يتم الموافقة عليه',
	rlwzc:'وجه غير مسجل',
	rlbfmzc:'وجه مسجل جزئياً',
	rlzcsb:'فشل تسجيل الوجه',
	xg:'تعديل',
	sccg:'نجحت الحذف',
	rybcz:'الموظف غير موجود',
	// 人员添加页面
	tjry:'إضافة موظف',
	yhxm:'اسم المستخدم',
	qsryhxm:'يرجى إدخال اسم المستخدم',
	zjhm:'رقم الوثيقة',
	bmxz:'اختيار القسم',
	yxkssj:'وقت البدء الصالح',
	xzrq:'اختيار التاريخ',
	yxjssj:'وقت الانتهاء الصالح',
	sztx:'تعيين الصورة الرمزية',
	bc:'حفظ',
	qxzxb:'يرجى اختيار الجنس',
	qsrzjh:'يرجى إدخال رقم الوثيقة',
	qsrkh:'يرجى إدخال رقم البطاقة',
	qsrgh:'يرجى إدخال رقم التعريف',
	qsrkmmm:'يرجى إدخال كلمة مرور فتح الباب',
	qsryxkssj:'يرجى إدخال وقت البدء الصالح',
	qsryxjssj:'يرجى إدخال وقت الانتهاء الصالح',
	ryycz:'الموظف موجود بالفعل',
	khycz:'رقم البطاقة موجود بالفعل',
	zcsbbcz:'جهاز التسجيل غير موجود',
	ghycz:'رقم التعريف موجود بالفعل',
	// 人员修改
	xgryzl:'تعديل بيانات الموظف',
	khbcz:'رقم البطاقة غير موجود',
	sbcwm:'فشل! رمز الخطأ',
	ryxxhqsb:'فشل الحصول على معلومات الموظف',
	// 权限分配
	sqzt:'حالة الصلاحية',
	wx:'غير صالح',
	yx:'صالح',
	tbzt:'حالة المزامنة',
	wtb:'لم يتم مزامنته',
	rlwtb:'الوجه لم يتم مزامنته',
	kwtb:'البطاقة لم يتم مزامنتها',
	sbmmwtb:'كلمة مرور الجهاز لم يتم مزامنتها',
	tb:'مزامنة',
	xz:'اختيار',
	qxqx:'تحديد الكل',
	sq:'إعطاء صلاحية',
	qxzsb:'يرجى اختيار الجهاز',
	qr:'تأكيد',
	qxzsqsb:'يرجى اختيار الجهاز المعتمد',
	bftbsb:'فشل المزامنة الجزئية',
	qcktbzt:'يرجى مراقبة حالة المزامنة',
	tbsbqcs:'فشل المزامنة، يرجى مراجعة ومحاولة مرة أخرى',
	bfscsb:'فشل الحذف الجزئي',
	scsbqcs:'فشل الحذف، يرجى مراجعة ومحاولة مرة أخرى',
	tjmk:'إضافة بطاقة الباب',
	rysc:'حذف الموظف',
	cg:'نجاح',
	删除成功:'حذف بنجاح',
    授权成功:'نجاح',

    //再次新加
	sygx1:'تحديد عشوائي 1',
	qrmm:'تأكيد كلمة المرور',
	zhmmyx:'البريد الإلكتروني لاستعادة كلمة المرور',
	zzhmm:'استعادة كلمة المرور',
	yxyzm:'رمز التحقق بالبريد الإلكتروني',
	hqyxyzm:'الحصول على رمز التحقق بالبريد الإلكتروني',
	dt:'قارئ',
	mj:'وصول',
	jin:'دخول',
	chu:'خروج',
	yes:'نعم',
	no:'لا',
	ysdyy:'هذه هي الصفحة الأولى',
	syy:'الصفحة السابقة',
	xyy:'الصفحة التالية',
	rmcs:'المدن الشهيرة',
	xzgjhdq:'اختيار الدولة أو المنطقة',
    zhhyzmcw:'خطأ في الحساب أو رمز التحقق',
    zhhmmcw:'خطأ في الحساب أو كلمة المرور',
    xyhzc:'تسجيل مستخدم جديد',
    yhm:'اسم المستخدم',
    qymc:'اسم الشركة',
    yx:'صالح',
    qsryx:'يرجى إدخال البريد الإلكتروني',
	yzms:'رمز التحقق هو',
    qsryxyzm:'يرجى إدخال رمز التحقق بالبريد الإلكتروني',
    yxyzm:'رمز التحقق بالبريد الإلكتروني غير صحيح!',
    yzmbzq:'رمز التحقق غير صحيح',
    qsryhm:'يرجى إدخال اسم المستخدم',
    hqyzmcg:'نجحت الحصول على رمز التحقق!',
    yhycz:'المستخدم موجود بالفعل',
    mm:'كلمة المرور',
    xmm:'كلمة مرور جديدة',
    xgmm:'تغيير كلمة المرور',
    jmm:'كلمة المرور القديمة',
    bf:'زيارة',
    qt:'محادثة',
    yycg:'نجح الحجز',
    yysb:'فشل الحجز',
    bfrbcz:'الشخص المقابل غير موجود',
    fkmhsjhmycz:'اسم الزائر أو رقم الجوال موجود بالفعل',
    mqtczsb:'فشل عملية MQTT',
    ljfghy:'مشاركة مع الأصدقاء على الفور',
    fzlj:'نسخ الرابط',
    bnzydqsj:'لا يمكن أن يكون سابقاً للوقت الحالي',
    yxqbn:'لا يمكن أن تزيد صلاحيته عن 7 أيام',
    rqxz:'التاريخ',
    szcg:'نجحت الإعداد',
    szsb:'فشل الإعداد',
    yhbcz:'المستخدم غير موجود',

    khkm:'فتح الباب برقم البطاقة',
    mmkm:'فتح الباب بكلمة المرور',
    zwkm:'فتح الباب بالبصمة',
    rlkm:'فتح الباب بالوجه',

    // 手机号国家区
    zgdl:'الصين القارية',
    zgxg:'هونج كونغ الصيني',
    zgam:'ماكاو الصيني',
    zgtw:'تايوان الصيني',
    afh:"أفغانستان",
    ade:'أندورا',
    agt:'الأرجنتين',
    ymny:'أرمينيا',
    alb:'أروبا',
    adl:"النمسا",
    asbj:'أذربيجان',

    bhm:'البهاما',
    bl:'البحرين',
    bbds:'بربادوس',
    bjst:'الباكستان',
	bx:'البرازيل',
    bels:'Белоруссия',
    bls:'بلجيكا',
	
    cxx:'كوريا الشمالية',
    cdjny:'غينيا الاستوائية',
    dg:'ألمانيا',
    dm:'الدانمرك',
    jbt:'جيبوتي',
    dmnjghg:'جمهورية الدومينيكان',
    els:'روسيا',
    egde:'إكوادور',
    aj:'مصر',
    aseby:'إثيوبيا',

    fg:'فرنسا',
    fl:'فنلندا',
    flb:'الفلبين',
    fdg:'الفاتيكان',

    gby:'غامبيا',
    ggghg:'جمهورية الكونغو',
    glby:'كولومبيا',
    gb:'كوبا',
    hg:'كوريا الجنوبية',
    hl:'الهولندا',
    hd:'هايتي',

    jbz:'كمبوديا',
    jlbs:'كيريباتي',
    jny:'غينيا',
    jbbw:"زيمبابوي",
    kml:'كاميرون',
    kmqt:'جزر كايمان',
    kny:'كينيا',
    kwt:'الكويت',
    kldy:'كرواتيا',
    lys:'لاوس',
    lby:'ليبيا',
    lwd:'رواندا',
    mg:'الولايات المتحدة',
    mlxy:'ماليزيا',
    mxg:'المكسيك',
    nf:'جنوب أفريقيا',
    nbe:'نيبال',
    nrly:'نيجيريا',
    nw:'النرويج',
    plqd:'جزر بالاوس',
    pty:'البرتغال',
    rb:'اليابان',
    rd:'السويد',
    rs:'سويسرا',
    stalb:'المملكة العربية السعودية',
    sd:'السودان',
    slxy:'سان لوسيا',
    tgs:'تايلاند',
    tjs:'تونغا',
    teq:'تركيا',
    wnrl:'فنزويلا',
    wl:'بروني',
    wkl:'أوكرانيا',
    xxl:'نيوزيلندا',
    xjb:'سنغافورة',
    xby:'إسبانيا',
    xl:'اليونان',
    xyl:'هنغاريا',
    ydl:'إيطاليا',
    yg:'المملكة المتحدة',
    ydnxy:'إندونيسيا',
    yd:'الهند',
    yn:'فيتنام',
    ylk:'العراق',
    zl:'شيلي',
    zfghg:'جمهورية أفريقيا الوسطى',


    wz:'الموقع',
    lym:'البلوتوث',
    kmcg:'نجح فتح الباب',
    kmsb:'فشل فتح الباب',
    qxdkly:'يرجى فتح البلوتوث أولاً',
    手机号码在同一个公司已存在:'رقم الجوال موجود بالفعل في نفس الشركة',
    有效期要大于当前时间:'يجب أن تكون صلاحيته أكبر من الوقت الحالي',
    请选择部门:'يرجى اختيار القسم',
    生成成功:  'نجحت الإنشاء',
    长按二维码下载:'احتفظ بالرمز الشعاعي لتنزيله',
    摄像头权限被拒绝:'تم رفض صلاحية الكاميرا',
    请先打开摄像头:'يرجى فتح الكاميرا أولاً',
    请在浏览器设置中开启摄像头权限:'يرجى تمكين صلاحية الكاميرا في إعدادات المتصفح ثم محاولة المسح مرة أخرى',
    知道了:'فهمت',
    加载中:'جارٍ التحميل',
    应用不支持蓝牙功能:'لا تدعم تطبيق Telegram ميزة البلوتوث. لاستخدام البلوتوث بشكل طبيعي، سيتم فتح ميزة البلوتوث في متصفح google-chrome',
    // 浏览器中打开蓝牙功能:'فتح ميزة البلوتوث في المتصفح',
    复制链接:'نسخ الرابط',
    中打开:'فتح في google-chrome',
    暂无部门:'لا توجد أقسام بعد',
    链接已复制:'تم نسخ الرابط',
    返回:'عودة',
    请将二维码对准摄像头:'يرجى محاذاة الرمز الشعاعي مع الكاميرا',

    免审参数:'المعايير المعفاة من المراجعة',
    自动授权截止时间:'موعد انتهاء التفويض التلقائي',
    请选择日期:'الرجاء اختيار التاريخ',
    自动授权口令:'إذن كلمة السر التلقائي',
    请输入口令:'الرجاء إدخال كلمة السر',
    自动授权开关:'إذن التبديل التلقائي',
    选择日期:'اختر التاريخ',

    logout  : "تسجيل الخروج",
    my      :'حسابي',
    scqx    :'حذف الأذونات',
    qxgl    :'إدارة الحقوق',
    qdzxzhm :'هل أنت متأكد من تسجيل الخروج؟',
    qtxkh   :'يرجى ملء رقم البطاقة',
    name    :'اسم المستخدم',
    qtxname :'يرجى ملء اسم المستخدم',
    pwas    :'كلمة السر',
    qtxpwas :'يرجى ملء كلمة المرور',
    zczh    :'رقم التسجيل',
    yzm     :'رمز التحقق',
    qtxyzm  :'يرجى ملء رمز التحقق',
    yyzhqqdl:'حساب موجود، انتقل إلى تسجيل الدخول',
    hqyzm   :'الحصول على رمز التحقق',
    fscg    :'إرسال بنجاح',
    fssb    :'فشل إرسال',



}
